module.exports = Backbone.View.extend({
	className: 'add-section',
	template: require('./add-section-view-template')
})
